import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  standalone: false,
  name: 'markdown'
})
export class MarkdownPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
    // Configure marked options - use minimal config for compatibility
    marked.setOptions({
      gfm: true, // GitHub Flavored Markdown
      breaks: true // Convert \n to <br>
    });
  }

  transform(value: string): SafeHtml {
    if (!value) return '';

    try {
      const html = marked.parse(value);
      return this.sanitizer.bypassSecurityTrustHtml(html as string);
    } catch (error) {
      console.error('Markdown parsing error:', error);
      return value;
    }
  }
}
